import { render, staticRenderFns } from "./JSONFormEditor.vue?vue&type=template&id=f65665f2&"
import script from "./JSONFormEditor.vue?vue&type=script&lang=js&"
export * from "./JSONFormEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/JSONFormEditor.vue
// module id = null
// module chunks = 